module.exports = __webpack_public_path__ + "static/media/hussmann_logo.c8dfb8f5.svg";